module.exports = __webpack_public_path__ + "static/media/fortmatic.ba76db0e.svg";